import { render } from "./OrderItemCard.vue?vue&type=template&id=10ac76f1"
import script from "./OrderItemCard.vue?vue&type=script&lang=js"
export * from "./OrderItemCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__